/**
 * @flow
 * @relayHash 241719bf46ca209575c6bec3b292fe71
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DeleteSettlementMutationVariables = {|
  id: string
|};
export type DeleteSettlementMutationResponse = {|
  +deleteSettlement: {|
    +id: string
  |}
|};
export type DeleteSettlementMutation = {|
  variables: DeleteSettlementMutationVariables,
  response: DeleteSettlementMutationResponse,
|};
*/


/*
mutation DeleteSettlementMutation(
  $id: String!
) {
  deleteSettlement(id: $id) {
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "id",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "deleteSettlement",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "SettlementModel",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "DeleteSettlementMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "DeleteSettlementMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "DeleteSettlementMutation",
    "id": null,
    "text": "mutation DeleteSettlementMutation(\n  $id: String!\n) {\n  deleteSettlement(id: $id) {\n    id\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'b551bc06bc823038d8f1ab1fc43ea2b2';
module.exports = node;
